/**
 * How a scrolling list offers to fetch a row the quick search wants.
 *
 * **The search must not navigate away from a list it could scroll to.** With
 * infinite scroll a match is often simply not loaded yet — on the filed reports
 * that is 2,719 rows, so a match can be twenty batches down — and opening the
 * client's record instead would take the reader out of the list they were
 * browsing and lose their place. Leaving and coming back is exactly the friction
 * infinite scroll removes, so the list loads up to the row and jumps there.
 * Arthur's ruling, 16 September.
 *
 * A page registers while it is mounted. The search asks the registered loader
 * first, and only navigates if there is none, or if the loader says the row is
 * not in this list at all — a client with no report, say, or one filtered out.
 */
export type RowLoader = (clientId: string) => Promise<boolean>;

let loader: RowLoader | null = null;

/** Registered by the list page for as long as it is on screen. */
export function setRowLoader(fn: RowLoader | null): void {
  loader = fn;
}

/** Null when the page on screen is not a list that can load more. */
export function rowLoader(): RowLoader | null {
  return loader;
}
